var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_656_2800",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 14,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333984 11.0801H13.5339V17.2251H0.333984V11.0801Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_656_2800)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93482 12.3301C3.38398 12.3301 1.58398 12.9401 1.58398 14.1442C1.58398 15.3592 3.38398 15.9751 6.93482 15.9751C10.4848 15.9751 12.284 15.3651 12.284 14.1609C12.284 12.9459 10.4848 12.3301 6.93482 12.3301ZM6.93482 17.2251C5.30232 17.2251 0.333984 17.2251 0.333984 14.1442C0.333984 11.3976 4.10148 11.0801 6.93482 11.0801C8.56732 11.0801 13.534 11.0801 13.534 14.1609C13.534 16.9076 9.76732 17.2251 6.93482 17.2251Z",
    fill: "#BABABA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_656_2800",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50977 0.666748H11.3598V9.51558H2.50977V0.666748Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_656_2800)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93563 1.8565C5.15146 1.8565 3.69979 3.30734 3.69979 5.0915C3.69396 6.86984 5.13479 8.31984 6.91146 8.3265L6.93563 8.9215V8.3265C8.71896 8.3265 10.1698 6.87484 10.1698 5.0915C10.1698 3.30734 8.71896 1.8565 6.93563 1.8565ZM6.93563 9.51567H6.90896C4.47396 9.50817 2.50146 7.52234 2.50979 5.089C2.50979 2.6515 4.49479 0.666504 6.93563 0.666504C9.37562 0.666504 11.3598 2.6515 11.3598 5.0915C11.3598 7.5315 9.37562 9.51567 6.93563 9.51567Z",
    fill: "#BABABA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOutlined);
export default __webpack_public_path__ + "static/media/profile-outlined.7ff2f2c7a0668f96976060643d6fb2d2.svg";
export { ForwardRef as ReactComponent };